import React from 'react';
import { CATS } from '../data/constants';
import { TURKEY_CITIES } from '../lib/turkey';
import { Maskot } from './Maskot';
import { getMaskotForCategory } from '../utils/maskot';

export function Filters({
  theme, MAPBOX_TOKEN,
  search, setSearch,
  userPos, setUserPos, setLocLabel,
  mapRef, showToast,
  selectedIl, setSelectedIl,
  selectedIlce, setSelectedIlce,
  ilDropdownOpen, setIlDropdownOpen,
  ilceDropdownOpen, setIlceDropdownOpen,
  ilQuery, setIlQuery,
  ilceQuery, setIlceQuery,
  ilBtnRef, ilceBtnRef, ilceCenterRef,
  selectedMahalleler, setSelectedMahalleler,
  mahalleQuery, setMahalleQuery,
  mahalleResults, mahalleSearching,
  mahallePanelOpen, setMahallePanelOpen,
  places, displayFiltered,
  activeCategory, setActiveCategory,
  selectedAgeGroup, setSelectedAgeGroup,
  priceRange, setPriceRange,
  sortBy, setSortBy,
  listView, setListView,
}) {
  const C = (k) => {
    const d = theme === 'dark';
    const m = {
      surf:d?'#141924':'#FFFAF5',
      surf2:d?'rgba(255,255,255,0.03)':'rgba(139,92,246,0.04)',
      bord:d?'rgba(255,255,255,0.07)':'rgba(139,92,246,0.10)',
      bord2:d?'rgba(255,255,255,0.12)':'rgba(139,92,246,0.14)',
      txt:d?'#ffffff':'#1E1048',
      txt2:d?'rgba(255,255,255,0.5)':'#4B3D7A',
      txt3:d?'rgba(255,255,255,0.25)':'#9B8FBD',
      inp:d?'rgba(255,255,255,0.05)':'rgba(139,92,246,0.06)',
    };
    return m[k]||'';
  };
  return (
    <div style={{padding:'10px 12px 8px',borderBottom:'1px solid '+C('bord'),flexShrink:0,overflowY:'auto'}}>
      {/* Search */}
      <div style={{display:'flex',gap:8,marginBottom:10}}>
        <div style={{flex:1,display:'flex',alignItems:'center',background:C('inp'),border:'1px solid '+C('bord'),borderRadius:11,padding:'0 12px',gap:8}}>
          <span style={{color:C('txt3'),fontSize:14}}>🔍</span>
          <input
            placeholder="Kurum ara..."
            value={search}
            onChange={function(e){setSearch(e.target.value);}}
            style={{flex:1,background:'none',border:'none',outline:'none',color:C('txt'),fontSize:13,padding:'9px 0',fontFamily:'DM Sans,sans-serif'}}
          />
        </div>
        <button onClick={function(){
          if (!navigator.geolocation) return;
          navigator.geolocation.getCurrentPosition(function(pos){
            setUserPos([pos.coords.longitude, pos.coords.latitude]);
            setSortBy('distance');
            setLocLabel('Konumunuz');
            if (mapRef.current) mapRef.current.flyTo({center:[pos.coords.longitude,pos.coords.latitude],zoom:14.5,duration:900});
          }, function() {
            showToast('Konum alınamadı. Tarayıcı ayarlarından konum iznini açın.');
            if (mapRef.current) mapRef.current.flyTo({center:[28.9784,41.0082],zoom:10,duration:900});
          }, {enableHighAccuracy:true,timeout:8000,maximumAge:0});
        }}
          style={{width:42,height:42,borderRadius:11,flexShrink:0,background:'linear-gradient(135deg,#A8DAFF,#7BB8F0)',border:'none',cursor:'pointer',fontSize:16}}>
          📍
        </button>
      </div>

      {/* İl / İlçe seçici — custom dropdown, yan yana */}
      {(()=>{
        const btnStyle = (open, hasVal, disabled) => ({
          width:'100%', background:C('surf'),
          border:'1px solid '+(open?'rgba(168,218,255,0.45)':C('bord2')),
          borderRadius:10, padding:'10px 14px',
          color: hasVal ? C('txt') : (disabled ? C('txt3') : C('txt2')),
          fontSize:13, cursor: disabled ? 'default' : 'pointer',
          fontFamily:'DM Sans,sans-serif', display:'flex', alignItems:'center',
          justifyContent:'space-between', textAlign:'left',
          boxSizing:'border-box', outline:'none',
          opacity: disabled ? 0.5 : 1,
        });
        const openPanel = (btnRef, setOpen, setOther, setOtherQ) => {
          setOther(false); setOtherQ('');
          setOpen(v => {
            if (!v && btnRef.current) {
              const r = btnRef.current.getBoundingClientRect();
              btnRef.current._rect = r;
            }
            return !v;
          });
        };
        const panelStyle = (btnRef) => {
          const r = btnRef.current?._rect;
          if (!r) return {};
          return {
            position:'fixed', top: r.bottom + 4, left: r.left,
            width: Math.max(r.width, 200),
            background:C('surf'), border:'1px solid '+C('bord2'),
            borderRadius:10, boxShadow:'0 8px 24px rgba(0,0,0,0.45)',
            zIndex:9999, overflow:'hidden',
          };
        };
        const searchStyle = {width:'100%',background:C('inp'),border:'1px solid '+C('bord2'),borderRadius:7,padding:'7px 10px',color:C('txt'),fontSize:12,outline:'none',fontFamily:'DM Sans,sans-serif',boxSizing:'border-box'};
        const itemStyle = (sel) => ({
          padding:'9px 14px', fontSize:13,
          color: sel ? '#A8DAFF' : C('txt'),
          cursor:'pointer',
          background: sel ? 'rgba(168,218,255,0.08)' : C('surf'),
          fontFamily:'DM Sans,sans-serif',
          borderBottom:'1px solid '+C('bord'),
        });
        return (
          <div style={{display:'flex',gap:8,marginBottom:10}}>
            {/* İl */}
            <div ref={ilBtnRef} style={{flex:1}}>
              <button onClick={()=>openPanel(ilBtnRef, setIlDropdownOpen, setIlceDropdownOpen, setIlceQuery)}
                style={btnStyle(ilDropdownOpen, !!selectedIl, false)}>
                <span style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{selectedIl||'İl seçin'}</span>
                <span style={{color:C('txt2'),fontSize:11,flexShrink:0,marginLeft:4,display:'inline-block',transform:ilDropdownOpen?'rotate(180deg)':'none',transition:'transform 0.15s'}}>▾</span>
              </button>
              {ilDropdownOpen && (
                <div style={panelStyle(ilBtnRef)}>
                  <div style={{padding:'6px 8px',borderBottom:'1px solid '+C('bord')}}>
                    <input key={'desk-il-'+ilDropdownOpen} defaultValue="" autoFocus onChange={e=>setIlQuery(e.target.value)} placeholder="İl ara..." style={searchStyle}/>
                  </div>
                  <div style={{maxHeight:240,overflowY:'auto'}}>
                    {TURKEY_CITIES.filter(c=>!ilQuery.trim()||c.il.toLowerCase().includes(ilQuery.toLowerCase())).map(c=>{
                      const sel = c.il===selectedIl;
                      return (
                        <div key={c.il}
                          onClick={()=>{ setSelectedIl(c.il); setSelectedIlce(''); setSelectedMahalleler([]); setIlDropdownOpen(false); setIlQuery(''); if(mapRef.current){ fetch('https://api.mapbox.com/geocoding/v5/mapbox.places/'+encodeURIComponent(c.il+' Türkiye')+'.json?access_token='+MAPBOX_TOKEN+'&country=TR&limit=1').then(r=>r.json()).then(d=>{ if(d.features?.[0]) mapRef.current.flyTo({center:d.features[0].center,zoom:10,duration:900}); }); } }}
                          style={itemStyle(sel)}
                          onMouseEnter={e=>{ if(!sel) e.currentTarget.style.background=C('surf2'); }}
                          onMouseLeave={e=>{ e.currentTarget.style.background=sel?'rgba(168,218,255,0.08)':C('surf'); }}>
                          {c.il}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
            {/* İlçe */}
            <div ref={ilceBtnRef} style={{flex:1}}>
              <button onClick={()=>{ if(!selectedIl) return; openPanel(ilceBtnRef, setIlceDropdownOpen, setIlDropdownOpen, setIlQuery); }}
                style={btnStyle(ilceDropdownOpen, !!selectedIlce, !selectedIl)}>
                <span style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{selectedIlce||'İlçe seçin'}</span>
                <span style={{color:C('txt2'),fontSize:11,flexShrink:0,marginLeft:4,display:'inline-block',transform:ilceDropdownOpen?'rotate(180deg)':'none',transition:'transform 0.15s'}}>▾</span>
              </button>
              {ilceDropdownOpen && selectedIl && (
                <div style={panelStyle(ilceBtnRef)}>
                  <div style={{padding:'6px 8px',borderBottom:'1px solid '+C('bord')}}>
                    <input key={'desk-ilce-'+ilceDropdownOpen} defaultValue="" autoFocus onChange={e=>setIlceQuery(e.target.value)} placeholder="İlçe ara..." style={searchStyle}/>
                  </div>
                  <div style={{maxHeight:240,overflowY:'auto'}}>
                    {(TURKEY_CITIES.find(c=>c.il===selectedIl)?.ilceler||[]).filter(d=>!ilceQuery.trim()||d.toLowerCase().includes(ilceQuery.toLowerCase())).map(d=>{
                      const sel = d===selectedIlce;
                      return (
                        <div key={d}
                          onClick={()=>{ setSelectedIlce(d); ilceCenterRef.current=null; setSelectedMahalleler([]); setIlceDropdownOpen(false); setIlceQuery(''); if(mapRef.current){ fetch('https://api.mapbox.com/geocoding/v5/mapbox.places/'+encodeURIComponent(d+' '+selectedIl+' Türkiye')+'.json?access_token='+MAPBOX_TOKEN+'&country=TR&limit=1').then(r=>r.json()).then(d2=>{ if(d2.features?.[0]){ ilceCenterRef.current=d2.features[0].center; setUserPos(d2.features[0].center); setLocLabel(d+', '+selectedIl); mapRef.current.flyTo({center:d2.features[0].center,zoom:13,duration:900}); } }); } }}
                          style={itemStyle(sel)}
                          onMouseEnter={e=>{ if(!sel) e.currentTarget.style.background=C('surf2'); }}
                          onMouseLeave={e=>{ e.currentTarget.style.background=sel?'rgba(168,218,255,0.08)':C('surf'); }}>
                          {d}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })()}

      {/* Mahalle seçimi — ilçe seçildikten sonra */}
      {selectedIlce && (
        <div style={{marginBottom:10}}>
          {/* Seçili chip'ler */}
          {selectedMahalleler.length > 0 && (
            <div style={{display:'flex',flexWrap:'wrap',gap:4,marginBottom:6,alignItems:'center'}}>
              {selectedMahalleler.map(m=>(
                <span key={m.name} style={{display:'inline-flex',alignItems:'center',gap:3,background:'rgba(168,218,255,0.12)',border:'1px solid rgba(168,218,255,0.35)',borderRadius:20,padding:'3px 8px 3px 11px',fontSize:12,color:'#A8DAFF',fontFamily:'DM Sans,sans-serif'}}>
                  {m.name}
                  <button onClick={()=>setSelectedMahalleler(prev=>prev.filter(x=>x.name!==m.name))} style={{background:'none',border:'none',color:'rgba(168,218,255,0.6)',cursor:'pointer',padding:'0 0 0 3px',fontSize:15,lineHeight:1,display:'flex',alignItems:'center'}}>×</button>
                </span>
              ))}
              <button onClick={()=>setSelectedMahalleler([])} style={{background:'none',border:'none',color:C('txt3'),fontSize:11,cursor:'pointer',padding:'2px 4px',fontFamily:'DM Sans,sans-serif'}}>Temizle</button>
            </div>
          )}
          {/* Dropdown tetikleyici */}
          <button onClick={()=>setMahallePanelOpen(v=>!v)}
            style={{width:'100%',background:C('surf'),border:'1px solid '+(mahallePanelOpen?'rgba(168,218,255,0.45)':C('bord2')),borderRadius:10,padding:'10px 14px',color:selectedMahalleler.length>0?C('txt'):C('txt2'),fontSize:13,cursor:'pointer',fontFamily:'DM Sans,sans-serif',display:'flex',alignItems:'center',justifyContent:'space-between',textAlign:'left',boxSizing:'border-box',outline:'none'}}>
            <span>{selectedMahalleler.length>0?selectedMahalleler.length+' mahalle seçildi':'Mahalle seçin'}</span>
            <span style={{color:C('txt2'),fontSize:11,transition:'transform 0.2s',display:'inline-block',transform:mahallePanelOpen?'rotate(180deg)':'none'}}>▾</span>
          </button>
          {/* Dropdown panel */}
          {mahallePanelOpen && (
            <div style={{background:C('surf'),border:'1px solid '+C('bord2'),borderRadius:10,marginTop:4,zIndex:200,boxShadow:'0 8px 24px rgba(0,0,0,0.3)',overflow:'hidden'}}>
              <div style={{padding:'8px 10px',borderBottom:'1px solid '+C('bord'),background:C('surf')}}>
                <input
                  placeholder="Ara..."
                  value={mahalleQuery}
                  onChange={e=>setMahalleQuery(e.target.value)}
                  autoFocus
                  style={{width:'100%',background:C('inp'),border:'1px solid '+C('bord2'),borderRadius:8,padding:'8px 12px',color:C('txt'),fontSize:13,outline:'none',fontFamily:'DM Sans,sans-serif',boxSizing:'border-box'}}
                />
              </div>
              <div style={{maxHeight:200,overflowY:'auto'}}>
                {mahalleSearching ? (
                  <div style={{padding:'14px 12px',color:C('txt3'),fontSize:13,textAlign:'center',fontFamily:'DM Sans,sans-serif'}}>Yükleniyor...</div>
                ) : mahalleResults.filter(r=>!mahalleQuery.trim()||r.name.toLowerCase().includes(mahalleQuery.toLowerCase())).length===0 ? (
                  <div style={{padding:'14px 12px',color:C('txt3'),fontSize:13,textAlign:'center',fontFamily:'DM Sans,sans-serif'}}>Mahalle bulunamadı</div>
                ) : mahalleResults.filter(r=>!mahalleQuery.trim()||r.name.toLowerCase().includes(mahalleQuery.toLowerCase())).map((r,ri)=>{
                  const isSel = !!selectedMahalleler.find(m=>m.name===r.name);
                  return (
                    <div key={ri+'-'+r.name} onClick={()=>{
                      if (isSel) {
                        setSelectedMahalleler(prev=>prev.filter(x=>x.name!==r.name));
                      } else {
                        const geocodeAndAdd = (center) => {
                          setSelectedMahalleler(prev=>[...prev,{name:r.name,center}]);
                          if (center && mapRef.current) mapRef.current.flyTo({center,zoom:14,duration:700});
                        };
                        const geoKey = 'okulmap_geo_'+r.name+','+selectedIlce;
                        const cached = (() => { try { const v=localStorage.getItem(geoKey); return v?JSON.parse(v):null; } catch(e){ return null; } })();
                        if (cached) { geocodeAndAdd(cached); } else {
                          fetch('https://api.mapbox.com/geocoding/v5/mapbox.places/'+encodeURIComponent(r.name+', '+selectedIlce+', '+selectedIl)+'.json?country=TR&language=tr&limit=1&access_token='+MAPBOX_TOKEN)
                            .then(res=>res.json())
                            .then(d=>{ const c=d.features?.[0]?.center||null; if(c) try{localStorage.setItem(geoKey,JSON.stringify(c));}catch(e){} geocodeAndAdd(c); })
                            .catch(()=>geocodeAndAdd(ilceCenterRef.current));
                        }
                      }
                    }}
                      style={{padding:'9px 14px',fontSize:13,color:isSel?'#A8DAFF':C('txt'),cursor:'pointer',borderBottom:'1px solid '+C('bord'),display:'flex',alignItems:'center',gap:10,background:isSel?'rgba(168,218,255,0.06)':C('surf'),fontFamily:'DM Sans,sans-serif',transition:'background 0.1s'}}
                      onMouseEnter={e=>{ if(!isSel) e.currentTarget.style.background=C('surf2'); }}
                      onMouseLeave={e=>{ e.currentTarget.style.background=isSel?'rgba(168,218,255,0.06)':C('surf'); }}>
                      <div style={{width:16,height:16,borderRadius:4,border:'1.5px solid '+(isSel?'#A8DAFF':C('bord2')),background:isSel?'rgba(168,218,255,0.2)':'transparent',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,fontSize:10,color:'#A8DAFF',fontWeight:700,transition:'all 0.15s'}}>
                        {isSel?'✓':''}
                      </div>
                      {r.name}
                    </div>
                  );
                })}
              </div>
              <div style={{padding:'8px 10px',borderTop:'1px solid '+C('bord'),display:'flex',justifyContent:'flex-end'}}>
                <button onClick={()=>setMahallePanelOpen(false)} style={{padding:'5px 14px',borderRadius:7,background:'rgba(168,218,255,0.1)',border:'1px solid rgba(168,218,255,0.25)',color:'#A8DAFF',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>Kapat</button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Active category mascot banner */}
      {activeCategory !== 'all' && (() => {
        const cat = CATS.find(c => c.id === activeCategory);
        if (!cat) return null;
        const mk = getMaskotForCategory(activeCategory);
        return (
          <div style={{display:'flex',alignItems:'center',gap:10,padding:'8px 12px',marginBottom:8,background:cat.color+'10',border:'1px solid '+cat.color+'30',borderRadius:10}}>
            <Maskot type={mk.type} name={mk.name} size={40} style={{flexShrink:0}}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{color:cat.color,fontSize:12,fontWeight:700,fontFamily:'DM Sans,sans-serif'}}>{cat.label}</div>
              <div style={{color:C('txt3'),fontSize:10}}>{displayFiltered.length} kurum gösteriliyor</div>
            </div>
          </div>
        );
      })()}

      {/* Categories */}
      <div style={{display:'flex',gap:5,flexWrap:'wrap',marginBottom:8}}>
        {CATS.map(function(cat){
          var isAct = activeCategory === cat.id;
          var count = cat.id==='all' ? places.length : places.filter(function(p){return p.type===cat.id;}).length;
          return (
            <button key={cat.id} onClick={function(){setActiveCategory(cat.id);}}
              style={{display:'flex',alignItems:'center',gap:4,padding:'4px 10px',borderRadius:8,border:'1px solid '+(isAct?cat.color+'60':C('bord')),background:isAct?cat.color+'18':'transparent',color:isAct?cat.color:C('txt2'),cursor:'pointer',fontSize:11,fontWeight:isAct?700:400,fontFamily:'DM Sans,sans-serif'}}>
              {cat.icon} {cat.label}
              <span style={{background:isAct?cat.color+'25':'rgba(255,255,255,0.06)',borderRadius:4,padding:'0 4px',fontSize:9,color:isAct?cat.color:C('txt3')}}>{count}</span>
            </button>
          );
        })}
      </div>

      {/* Yaş grupları */}
      <div style={{display:'flex',gap:4,marginBottom:10,flexWrap:'wrap'}}>
        <span style={{color:C('txt3'),fontSize:10,fontWeight:600,alignSelf:'center',letterSpacing:'0.06em',marginRight:2}}>YAŞ</span>
        {[{id:'0-2',label:'0-2'},{id:'2-5',label:'2-5'},{id:'5-12',label:'5-12'},{id:'12+',label:'12+'}].map(g=>{
          const isAct = selectedAgeGroup === g.id;
          return (
            <button key={g.id} onClick={()=>setSelectedAgeGroup(isAct ? null : g.id)}
              style={{padding:'3px 9px',borderRadius:20,fontSize:11,fontWeight:isAct?700:400,cursor:'pointer',fontFamily:'DM Sans,sans-serif',background:isAct?'rgba(168,218,255,0.18)':'transparent',border:'1px solid '+(isAct?'rgba(168,218,255,0.5)':C('bord')),color:isAct?'#A8DAFF':C('txt2'),transition:'all 0.15s'}}>
              {g.label}
            </button>
          );
        })}
      </div>

      {/* Aktif filtre chip'leri */}
      {(()=>{
        const chips = [];
        if (activeCategory !== 'all') { const cat=CATS.find(c=>c.id===activeCategory); chips.push({label:cat?.icon+' '+(cat?.label||''), color:cat?.color||'#A8DAFF', clear:()=>setActiveCategory('all')}); }
        if (selectedAgeGroup) chips.push({label:'👶 '+selectedAgeGroup+' yaş', color:'#4ECDC4', clear:()=>setSelectedAgeGroup(null)});
        if (priceRange[0]>0||priceRange[1]<6000) chips.push({label:'₺'+(priceRange[0]>0?priceRange[0].toLocaleString('tr'):'0')+'-'+(priceRange[1]<6000?priceRange[1].toLocaleString('tr'):'6k'), color:'#FFE66D', clear:()=>setPriceRange([0,6000])});
        if (selectedMahalleler.length>0) chips.push({label:'📍 '+selectedMahalleler.length+' mahalle', color:'#FF6B8A', clear:()=>setSelectedMahalleler([])});
        if (selectedIlce) chips.push({label:'🏘 '+selectedIlce, color:'#C77DFF', clear:()=>{ setSelectedIlce(''); setSelectedMahalleler([]); }});
        if (search) chips.push({label:'🔍 "'+search+'"', color:'#A8DAFF', clear:()=>setSearch('')});
        if (!chips.length) return null;
        return (
          <div style={{display:'flex',flexWrap:'wrap',gap:5,marginBottom:8}}>
            {chips.map((ch,i)=>(
              <span key={i} style={{display:'inline-flex',alignItems:'center',gap:4,background:ch.color+'15',border:'1px solid '+ch.color+'40',borderRadius:20,padding:'3px 8px 3px 10px',fontSize:11,color:ch.color,fontFamily:'DM Sans,sans-serif',fontWeight:600}}>
                {ch.label}
                <span onClick={ch.clear} style={{cursor:'pointer',opacity:0.7,fontSize:13,lineHeight:1,marginLeft:1}}>×</span>
              </span>
            ))}
            {chips.length>1&&<span onClick={()=>{ setActiveCategory('all'); setSelectedAgeGroup(null); setPriceRange([0,6000]); setSelectedMahalleler([]); setSelectedIlce(''); setSelectedIl(''); setSearch(''); }} style={{display:'inline-flex',alignItems:'center',padding:'3px 9px',borderRadius:20,fontSize:11,color:C('txt3'),border:'1px solid '+C('bord'),cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>Temizle</span>}
          </div>
        );
      })()}

      {/* Sort + View toggle */}
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div style={{color:C('txt2'),fontSize:12}}>
          <span style={{color:C('txt'),fontWeight:700}}>{displayFiltered.length}</span> kurum
        </div>
        <div style={{display:'flex',gap:4,alignItems:'center'}}>
          {[{id:'distance',label:'Yakın'},{id:'rating',label:'Puan'},{id:'price',label:'Fiyat'}].filter(s=>s.id!=='distance'||userPos).map(function(s){
            var isAct = sortBy === s.id;
            return (
              <button key={s.id} onClick={function(){setSortBy(s.id);}}
                style={{padding:'3px 8px',borderRadius:5,fontSize:10,background:isAct?'rgba(168,218,255,0.14)':'rgba(255,255,255,0.04)',border:'1px solid '+(isAct?'rgba(168,218,255,0.4)':C('bord')),color:isAct?'#A8DAFF':C('txt3'),cursor:'pointer',fontWeight:isAct?700:400,fontFamily:'DM Sans,sans-serif'}}>
                {s.label}
              </button>
            );
          })}
          <div style={{width:1,height:14,background:C('bord'),margin:'0 2px'}}/>
          {[{id:'list',icon:'☰'},{id:'grid',icon:'⊞'}].map(v=>(
            <button key={v.id} onClick={()=>setListView(v.id)}
              style={{width:24,height:24,borderRadius:5,border:'1px solid '+(listView===v.id?'rgba(168,218,255,0.4)':C('bord')),background:listView===v.id?'rgba(168,218,255,0.14)':'rgba(255,255,255,0.04)',color:listView===v.id?'#A8DAFF':C('txt3'),cursor:'pointer',fontSize:12,display:'flex',alignItems:'center',justifyContent:'center'}}>
              {v.icon}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
